import {useCallback} from 'react';

import {Spinner} from '../../../../../layout/spinner/spinner';
import {ReviewNoteType, useNotes} from '../../../../../service/reviews/reviews-notes';
import {useReviewStateHook} from '../../reviews-state/reviews-state-provider';

import {ReviewNoteListItem} from './review-note-list-item';
import * as styles from './new-review-notes.scss';

type PropsType = {
    reviewId: number;
    notesCount: number;
};

export function NewReviewNotes(props: PropsType): JSX.Element | null {
    const {reviewId, notesCount} = props;
    const {data: notesList, isFetching: isInProgress} = useNotes(reviewId, notesCount > 0);
    const {updateReview} = useReviewStateHook();

    const syncNotes = useCallback(
        (nextNotes: Array<ReviewNoteType>) => {
            updateReview(reviewId, {notes: nextNotes});
        },
        [reviewId, updateReview]
    );

    const noteResults = notesList?.results ?? [];

    return (
        <div className={styles.ReviewNotes}>
            <Spinner isShow={isInProgress} position="absolute" />
            {noteResults.map((note: ReviewNoteType) => {
                return (
                    <ReviewNoteListItem
                        allNotes={noteResults}
                        key={note.id}
                        note={note}
                        reviewId={reviewId}
                        syncNotes={syncNotes}
                    />
                );
            })}
        </div>
    );
}
